import * as React from "react";
import styled, { css } from "styled-components";

import { useWindowSize } from "src/library/hooks/useWindowSize";
import HtmlBody from "src/library/components/Notes/HtmlBody";
import { S3Video } from "src/core/shared/components/S3";
import { ISupport } from "src/modules/support/api/support.api";
import { S3PDF } from "src/core/shared/components/S3/S3PDF";

const SupportDocumentModal: React.ReactFCWithChildren<{ supportDocument: ISupport }> = ({ supportDocument }) => {
  const windowDimensions = useWindowSize();

  const videoDimensions = React.useMemo(() => {
    if (windowDimensions && windowDimensions.height && windowDimensions.width) {
      return {
        height: windowDimensions.height - 150,
        width: windowDimensions.width - 100
      };
    }

    return {
      height: 500,
      width: 800
    };
  }, [ windowDimensions ]);

  return (
    <ModalInner
      style={supportDocument.type === "VIDEO" ? {
        maxHeight: videoDimensions.height + 25,
        maxWidth: videoDimensions.width + 25
      } : {}}
    >
      {!!supportDocument.s3Key && supportDocument.type === "VIDEO" && (
        <S3Video
          className="support-video"
          width={videoDimensions.width}
          height={videoDimensions.height}
          level="public"
          s3Key={supportDocument.s3Key}
        />
      )}

      {!!supportDocument.s3Key && supportDocument.type === "PDF" &&
      (
        <S3PDF s3Key={supportDocument.s3Key} />
      )}

      {!!supportDocument.description && (
        <div className="description-wrapper">
          <HtmlBody body={supportDocument.description} />
        </div>
      )}
    </ModalInner>
  );
};

const ModalInner = styled.div`
${({ theme }) => css`
    overflow-y: scroll;

    .description-wrapper {
      margin-top: ${theme.spacing.margins.md};
    }

    .pdf-page-wrapper {
      border-bottom: ${theme.colors.lightGrey} 1px solid; 
    }
  `}
`;

export default SupportDocumentModal;
